import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "order-card-top" };
const _hoisted_2 = { class: "left" };
const _hoisted_3 = {
    key: 0,
    title: "localhost개발환경에서만 보입니다."
};
const _hoisted_4 = {
    key: 1,
    title: "localhost개발환경에서만 보입니다."
};
const _hoisted_5 = { class: "right" };
const _hoisted_6 = { class: "pay-type" };
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = ["title"];
const _hoisted_10 = ["title"];
const _hoisted_11 = ["title"];
const _hoisted_12 = { class: "right" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_OrderStatusChip = _resolveComponent("OrderStatusChip");
    const _component_Chip = _resolveComponent("Chip");
    const _component_PayType = _resolveComponent("PayType");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        class: _normalizeClass(["root-order-item", _ctx.cssClassOrderItem]),
        tile: "",
        variant: "outlined",
        ripple: false,
        "data-cy": "order-item",
        onClick: _ctx.handleClickOrderItem,
        onMouseenter: _ctx.handleMouseEnterOrder,
        onMouseleave: _ctx.handleMouseLeaveOrder
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card_text, {
                title: `${_ctx.orderData.distributorId} / ${_ctx.orderData.hubId} / ${_ctx.orderData.storeId} / ${_ctx.orderData.orderId}`,
                class: "order-card-body"
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 주문 상세 버튼 "),
                    _withDirectives(_createVNode(_component_v_btn, {
                        small: "",
                        variant: "outlined",
                        height: "40",
                        class: _normalizeClass(`btn-detail-order cy-order-item-${_ctx.orderData.orderId}`),
                        "data-cy": "detail-order-button",
                        title: "상세정보",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.setIsOpenModalOrderInfo(_ctx.orderData.orderId)), ["stop"]))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "20" }, {
                                default: _withCtx(() => [
                                    _cache[1] || (_cache[1] = _createTextVNode(" mdi-magnify ")),
                                    _createCommentVNode(" {{ $t(lc + 'order_info') }} ")
                                ]),
                                _: 1 /* STABLE */,
                                __: [1]
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]), [
                        [_vShow, _ctx.showClickButton]
                    ]),
                    _createCommentVNode(" 공유건 여부 태그 "),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "order-color-tag" }, null, -1 /* CACHED */)),
                    _createCommentVNode(" top "),
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" top-left "),
                        _createElementVNode("div", _hoisted_2, [
                            (_ctx.debugIsLocalhost && _ctx.orderData.isAddressBaseOrder())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (주) "))
                                : _createCommentVNode("v-if", true),
                            (_ctx.debugIsLocalhost && _ctx.orderData.isB2B())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (B) "))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" 주문 상태 칩 "),
                            _createVNode(_component_OrderStatusChip, {
                                "status-code": _ctx.orderData.statusCode
                            }, null, 8 /* PROPS */, ["status-code"]),
                            _createCommentVNode(" 주소기반배달 관련 단건, 묶음 여부 "),
                            (_ctx.orderData?.orderAgencyOptions?.allocateLimit === 1)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 2,
                                    "brg-chip-color": _ctx.agencyOrderColor,
                                    text: _ctx.agencyOrderText
                                }, null, 8 /* PROPS */, ["brg-chip-color", "text"]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" 주류 여부 "),
                            (_ctx.isIncludeAlcohol)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 3,
                                    "brg-chip-color": "red",
                                    text: "19"
                                }))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" 비대면 칩 "),
                            (_ctx.isUntact)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 4,
                                    "brg-chip-color": "blue",
                                    title: _ctx.$t('common.untact'),
                                    text: _ctx.$t('common.untact_short')
                                }, null, 8 /* PROPS */, ["title", "text"]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" 지연 시간 "),
                            _createElementVNode("span", {
                                class: _normalizeClass(["remain-time", _ctx.intervalDisplayTime.color])
                            }, _toDisplayString(_ctx.intervalDisplayTime.text), 3 /* TEXT, CLASS */)
                        ]),
                        _createCommentVNode(" top-right "),
                        _createElementVNode("div", _hoisted_5, [
                            _createCommentVNode(" 납부 방식, 현금, 카드, 선납 "),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_PayType, { "pay-types": _ctx.payTypes }, null, 8 /* PROPS */, ["pay-types"])
                            ]),
                            _createCommentVNode(" 주문 금액 "),
                            _createElementVNode("span", {
                                title: `주문 금액: ${_ctx.orderAmount}`,
                                class: "order-amount ml-1"
                            }, _toDisplayString(_ctx.orderAmount), 9 /* TEXT, PROPS */, _hoisted_7),
                            _cache[2] || (_cache[2] = _createTextVNode(" / ")),
                            _createCommentVNode(" 배차 라이더 "),
                            (_ctx.isShowWorkerName)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    title: _ctx.orderData.allocatedWorkerName,
                                    class: "delivery-amount"
                                }, _toDisplayString(_ctx.orderData.allocatedWorkerName), 9 /* TEXT, PROPS */, _hoisted_8))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" 배달 대행료 "),
                                    _createElementVNode("div", {
                                        title: `배달 대행료: ${_ctx.deliveryAmount}`,
                                        class: "delivery-amount"
                                    }, _toDisplayString(_ctx.deliveryAmount), 9 /* TEXT, PROPS */, _hoisted_9)
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ])
                    ]),
                    _createCommentVNode(" middle "),
                    _createElementVNode("div", null, [
                        _createCommentVNode(" 픽업주소, 출발지 메모 (상점주소), 메모 등등 "),
                        _createElementVNode("div", {
                            title: `출발지 주소 or 출발지 메모: ${_ctx.orderBodyText}`,
                            class: _normalizeClass(_ctx.pickupInfoClass)
                        }, [
                            _createCommentVNode(" <div>\n              상점코드:\n              {{ orderData.storeId }}\n            </div> "),
                            _createCommentVNode(" <div>\n              orderId:\n              {{ orderData.orderId }}\n            </div> "),
                            _createCommentVNode(" {{ orderData.storeId }}\n            /\n            {{ orderData.orderId }}\n            / "),
                            _createTextVNode(" " + _toDisplayString(_ctx.orderBodyText), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_10)
                    ]),
                    _createCommentVNode(" bottom "),
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.orderCardBottomClass)
                    }, [
                        _createCommentVNode(" 도착지 주소 "),
                        _createElementVNode("div", {
                            title: `도착지 주소: ${_ctx.orderDropAddress}`,
                            class: "left"
                        }, _toDisplayString(_ctx.orderDropAddress), 9 /* TEXT, PROPS */, _hoisted_11),
                        _createCommentVNode(" 거리 "),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.orderData.distanceKilometer) + " " + _toDisplayString(_ctx.$t('common.km')), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                ]),
                _: 1 /* STABLE */,
                __: [3]
            }, 8 /* PROPS */, ["title"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onClick", "onMouseenter", "onMouseleave"]));
}
